<template>
  <el-dialog title="实名认证" :visible.sync="showRealname" center width="60%" :show-close='false' :close-on-click-modal="false">
    <ul class="realname">
      <li>
        <span>学员姓名：</span>
        <div class="infor">
          <p>{{realnameList.realname}}</p>
        </div>
      </li>
      <li>
        <span>身份证号：</span>
        <div class="infor">
          <p>{{realnameList.idcard}}</p>
        </div>
      </li>
      <li>
        <span>手机号：</span>
        <div class="infor">
          <p>{{realnameList.phone}}</p>
        </div>
      </li>
      <li class="one_inch_img">
        <span>证件照：</span>
        <div class="infor">
          <img :src="realnameList.one_inch_img" />
        </div>
      </li>
      <li>
        <span>身份证人像面：</span>
        <div class="infor">
          <img :src="realnameList.idcard_img_front" />
        </div>
      </li>
      <li>
        <span>身份证国徽面：</span>
        <div class="infor">
          <img :src="realnameList.idcard_img_back" />
        </div>
      </li>
    </ul>
    <el-form :model="form" :label-width="formLabelWidth"  :rules="rules">
      <el-form-item label="审核状态：" prop="status">
        <el-radio
          v-model="form.status"
          v-for="(item,index) in radioList"
          :key="index"
          :label="item.id"
          :checked="item.checked"
          :disabled="item.disabled"
          :value="item.id">{{item.name}}
        </el-radio>
      </el-form-item>
      <el-form-item label="审核原因：" v-if="form.status === 2">
        <el-input type="textarea" v-model="realnameList.renzheng_reson" :disabled="realnameList.renzheng_status === 15"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="concel">取 消</el-button>
      <el-button type="primary" @click="confirm" v-if="realnameList.renzheng_status != 15">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
  export default{
    name:'authentication',
    data(){
      return {
        formLabelWidth: '100px',
        form:{
          status:1,
          reson:''
        },
        rules:{
          status:[{ required: true, message: '请选择审核状态', trigger: 'change' }],
        },
        radioList:[
          {
            name:'通过',id:1,checked:false,disabled:false
          },{
            name:'不通过',id:2,checked:false,disabled:false
          },
        ]
      }
    },
    props:{
      showRealname:{
        type:Boolean,
        default:Boolean
      },
      realnameList:{
        type:Object,
        default:function(){}
      },
      studentId:{
        type:String
      },
    },
    created(){
    },
    mounted(){
      if(this.realnameList.renzheng_status != 15){
        this.form.status = 2
        this.radioList[1].checked = true
        this.form.reson = this.realnameList.renzheng_reson
      }else{
        this.radioList[0].disabled = true
        this.form.status = 1
        this.radioList[0].checked = true
        this.radioList[1].disabled = true
      }
    },
    methods:{
      confirm(){
        this.form.reson = this.realnameList.renzheng_reson
        this.$emit('realnameConfirm',this.form)
      },
      concel(){
        this.$emit('realnameConcel')
      },
      
    },
  }
</script>
<style scoped lang="scss">
  @import '../../../assets/scss/authentication.scss';
</style>